import store from '@/store'
import { hasValidRole } from '../data/userRoles'
import router from '../router'

export default (to, from, next) => {
  if (store.getters.user) {
    console.log('user detail ', store.getters.user)
    if (!hasValidRole(store.getters.user)) {
      console.log('has NO valid role, result is ', hasValidRole(store.getters.user))
      //router.push({name:"noaccess"}).catch()
      //next('/app/sessions/noaccess')
    } 
  }
  if (
    localStorage.getItem('userInfo') != null &&
    localStorage.getItem('userInfo').length > 0 &&
    store.getters.user
  ) {
    console.log('###### userInfo local ', localStorage)
    next()
  } else {
    console.log('has NO valid role, result is ')
    localStorage.removeItem('userInfo')
    router.push({name:"sign-in"}).catch()

    // next('/app/sessions/sign-in')
  }
}


// export default (to, from, next) => {
//   if (store.getters.user) {
//     console.log('user detail ', store.getters.user)
//     if (!hasValidRole(store.getters.user)) {
//       console.log('has NO valid role, result is ', hasValidRole(store.getters.user))
//       next('/app/sessions/noaccess')
//     }
//   } else {
//     next('/app/sessions/sign-in')
//   }
//   if (
//     localStorage.getItem('userInfo') != null &&
//     localStorage.getItem('userInfo').length > 0
//   ) {
//     next()
//   } else {
//     localStorage.removeItem('userInfo')
//     next('/app/sessions/sign-in')
//   }
// }